// Master exam configuration registry for the Exam Simulator.
// Configs live in ./exams/* split by qualification; this file normalises
// and exposes them. Timings and question counts verified against official
// sources (College Board, ACT.org, AQA/Edexcel/OCR, IBO) — July 2026 formats.

import { SAT_ACT_CONFIGS } from './exams/satAct';
import { AP_CONFIGS } from './exams/ap';
import { UK_CONFIGS } from './exams/uk';
import { IB_CONFIGS } from './exams/ib';

const SECTION_DEFAULTS = {
  calculator: false,
  desmos: false,
  formulaSheet: null,
  adaptive: false,
  optional: false,
  questionTypes: ['mcq'],
};

const normalise = (config) => ({
  breaks: [],
  ...config,
  sections: config.sections.map(s => ({ ...SECTION_DEFAULTS, ...s })),
});

export const EXAM_CONFIGS = [
  ...SAT_ACT_CONFIGS,
  ...AP_CONFIGS,
  ...UK_CONFIGS,
  ...IB_CONFIGS,
].map(normalise);

export const EXAM_GROUPS = ['Admissions Tests', 'AP', 'GCSE', 'A-Level', 'IB'];

export const getExamConfig = (id) => EXAM_CONFIGS.find(e => e.id === id) || null;

// Best-effort match from a Learnable subject (name + qualification) to an exam
// config, used by entry points on Subject/Dashboard ("Practice exam" buttons).
export const matchExamForSubject = (subject) => {
  if (!subject) return null;
  const hay = `${subject.qualification || ''} ${subject.name || ''}`.toLowerCase();
  let best = null;
  let bestLen = 0;
  for (const exam of EXAM_CONFIGS) {
    for (const kw of exam.match || []) {
      if (hay.includes(kw) && kw.length > bestLen) { best = exam; bestLen = kw.length; }
    }
  }
  return best;
};

export const getBreakAfter = (config, sectionId) =>
  (config.breaks || []).find(b => b.after === sectionId) || null;
